import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react'

import {
  AUTH_STORAGE_KEYS,
  clearAuthStorage,
  get,
  setAuthStorage,
} from '@/utils/storage/adapters/localStorageAdapter'

import { RefreshTokenResponseDto } from './Auth/AuthService.dto'

const url = import.meta.env.VITE_API_BASE_URL

const baseQuery = fetchBaseQuery({
  baseUrl: url,
  prepareHeaders: (headers) => {
    const token = get(AUTH_STORAGE_KEYS.token)
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    return headers
  },
})

const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  let result = await baseQuery(args, api, extraOptions)

  if (result.error?.status === 401) {
    const refreshToken = get(AUTH_STORAGE_KEYS.refreshToken)

    if (!refreshToken) {
      clearAuthStorage()
      return result
    }

    const refreshResult = await baseQuery(
      {
        url: 'auth/RefreshToken/refresh-token',
        method: 'POST',
        body: { refreshToken },
      },
      api,
      extraOptions
    )

    if (refreshResult.data) {
      const refreshData = refreshResult.data as RefreshTokenResponseDto

      setAuthStorage({
        token: refreshData.accessToken.token,
        tokenExpiresAt: refreshData.accessTokenExpires,
        refreshToken: refreshData.refreshToken,
        refreshTokenExpiresAt: refreshData.refreshTokenExpires,
      })

      result = await baseQuery(args, api, extraOptions)
    } else {
      clearAuthStorage()
      window.location.href = '/login'
    }
  }

  return result
}

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Auth', 'DriverStatus', 'WorkStatus', 'Status'],
  endpoints: () => ({}),
})
